import { connect } from 'react-redux';

import Actions from '../../Actions/Creators';
import DialogForgotPassword from './Component/DialogForgotPassword';


const mapStateToProps = (state, ownProps) => ({
    verifyOtp: state.verifyOtp,
    loginStatus: state.auth.loginErrorCode,
    isAuthenticated: state.auth.isAuthenticated,
    signUpStatus: state.auth.userSignUpStatus,

    isLoading: state.auth.isLoading,

    isOTPSend: state.communication.isOTPSend
});


const mapDispatchToProps = (dispatch) => ({
    fetchUserSignUpStatus: (username) => dispatch(Actions.fetchUserSignUpStatus(username)),

    sendOtp: (phone, email, userId) => dispatch(Actions.sendOtp(phone, email, userId)),
    sendMagicLink: (magicLink, email, phone) => dispatch(Actions.sendMagicLink(magicLink, email, phone)),

    loginUser: (payload, persistent, isGuest) => dispatch(Actions.loginUser(payload, persistent, isGuest)),
    changePassword: (password) => dispatch(Actions.changePassword(password, true)),
});


export default connect(mapStateToProps, mapDispatchToProps)(DialogForgotPassword)